import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export function useFunnelsApi() {
  const { apiFetch } = useAuth();

  return useMemo(
    () => ({
      getAll: () => apiFetch("/funnels"),

      getPipeline: ({ funnelId, stalledDays } = {}) => {
        const params = new URLSearchParams();
        if (funnelId) params.append("funnelId", funnelId);
        if (stalledDays) params.append("stalledDays", stalledDays);
        return apiFetch(`/funnels/pipeline?${params.toString()}`);
      },

      getById: (id) => apiFetch(`/funnels/${id}`),

      create: (funnelData) =>
        apiFetch("/funnels", {
          method: "POST",
          body: JSON.stringify(funnelData),
        }),

      update: (id, funnelData) =>
        apiFetch(`/funnels/${id}`, {
          method: "PUT",
          body: JSON.stringify(funnelData),
        }),

      remove: (id) =>
        apiFetch(`/funnels/${id}`, {
          method: "DELETE",
        }),

      incrementUsage: (id) =>
        apiFetch(`/funnels/${id}/increment`, {
          method: "PATCH",
        }),
    }),
    [apiFetch],
  );
}
